"use client";
import Image from "next/image";
import { Row, Col, Collapse, Divider, Space } from "antd";
import type { CollapseProps } from "antd";
import FloatButton from "../floatbutton/index";
import Link from "next/link";
import Facebook from "@/app/assets/footor/facebook.svg";
import Pinterest from "@/app/assets/footor/pinterest.svg";
import Youtub from "@/app/assets/footor/youtub.svg";
import Instagram from "@/app/assets/footor/instagram.svg";
import { PrivacyPolicyPagesEnum } from "@/utils/const";
import { returnPricacyPolicyUrl } from "@/utils/tools";
import useMobileDetect from "@/hooks/useMobileDetect";
import "./index.css";

export default function Footer(props: {eventName?: string}) {

  return (
    <div className="layout-footor">
      {/* {!isMobile && <FloatButton />} */}
      <FloatButton eventName={props.eventName} />
    </div>
  );
}
